export default {"src":"/_next/static/media/cogs_text.8563722e.svg","height":89,"width":308};